(function ($) {
    var iconWidth = 400;
    var iconHeight = 400;
    /* This function will render a Google Map onto the selected jQuery element*/

    function new_map($el) {
        var $markers = $el.find(".marker");

        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                position: google.maps.ControlPosition.TOP_LEFT,
            },
            zoomControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            scaleControl: false,
            streetViewControl: false,
            fullscreenControl: true,
            fullscreenControl: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        var customZoomInControlDiv = document.createElement("div");
        var customZoomInControl = new CustomZoomInControl(customZoomInControlDiv, map);

        customZoomInControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(customZoomInControlDiv);

        var customZoomOutControlDiv = document.createElement("div");
        var customZoomOutControl = new CustomZoomOutControl(customZoomOutControlDiv, map);

        customZoomOutControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(customZoomOutControlDiv);

        map.setOptions({
            styles: [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 65,
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            hue: "#FF0000",
                        },
                        {
                            lightness: "-6",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: "50",
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "40",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            hue: "#FFFF00",
                        },
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -97,
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -100,
                        },
                    ],
                },
            ],
        });

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function () {
            add_marker($(this), map);
        });

        // center map
        center_map(map);

        google.maps.event.addListener(map, "click", function (event) {
            $.closeAllInfoWindow();
        });

        // return
        return map;
    }

    /* This function will add a marker to the selected Google Map*/

    function add_marker($marker, map) {
        // var
        var latlng = new google.maps.LatLng($marker.attr("data-lat"), $marker.attr("data-lng"));

        var markerImage = $marker.attr("data-marker");
        var makerSize = $marker.attr("data-marker-size");

        var scaledSize = new google.maps.Size(129, 130);

        if (makerSize != undefined && makerSize == "small") {
            scaledSize = new google.maps.Size(40, 40);
        }

        var isVisible = $marker.data("visible");

        var pid = $marker.attr("data-id");

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            id: pid && pid != "" ? pid : "",
            visible: isVisible != undefined ? isVisible : true,
            optimized: false,
            icon: {
                url: markerImage && markerImage != "" ? markerImage : null,
                scaledSize: scaledSize
            },
        });

        if ($marker.html()) {


            marker['infowindow'] = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
                if (currentMarker != this) {


                    $.closeAllInfoWindow();


                    currentInfoWindow = this['infowindow'];
                    currentMarker = this;
                    currentInfoWindow.open(map, this);

                }
            });

        } else {

            marker.addListener("click", function () {
                map.setZoom(18);
                map.setCenter(marker.getPosition());
                map.panBy(0, -iconHeight / 2);
            });
        }


        // add to array
        map.markers.push(marker);



    }



    $.closeAllInfoWindow = function closeAllInfoWindow() {
        if (currentInfoWindow) {
            currentInfoWindow.close();
            currentInfoWindow = null;
        }
        if (currentMarker) {
            currentMarker = null;
        }
    }


    $(document).on('click', '.js-close-infowindow', function (e) {
        e.preventDefault();
        $.closeAllInfoWindow();
    });


    /* This function will center the map, showing all markers attached to this map */

    function center_map(map) {
        var bounds = new google.maps.LatLngBounds();
        var numofmarker = 0;

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            if (marker.visible) {
                numofmarker++;
                bounds.extend(latlng);
            }
        });

        /*If not enough markers add dummy points for better zoomin*/
        var minDistance = 0.002;
        var sumA = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
        var sumB = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();

        if (sumA < minDistance && sumA > -minDistance && sumB < minDistance && sumB > -minDistance) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + minDistance, bounds.getNorthEast().lng() + minDistance);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - minDistance, bounds.getNorthEast().lng() - minDistance);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

        if (numofmarker > 0) {
            // only 1 marker?
            if (map.markers.length == 1) {
                // set center of map
                map.setCenter(bounds.getCenter());
                map.setZoom(16);
            } else {
                if ($('.js-template-marina-city').length) {
                    map.setCenter(bounds.getCenter());
                    map.setZoom(16);
                } else {
                    map.fitBounds(bounds);
                }

            }
        }

        map.panBy(0, -iconHeight / 2);
    }

    /* This function will render each map when the document is ready (page has loaded)*/

    $.smap = null;
    var currentInfoWindow = null;
    var currentMarker = null;

    $.setMarker = function setMarker(pid) {
        var visiblePinCounter = 0;
        for (var i = 0; i < $.smap.markers.length; i++) {
            var markertohide = $.smap.markers[i];

            if (markertohide.id == pid) {
                markertohide.setVisible(true);
                visiblePinCounter++;
            } else {
                markertohide.setVisible(false);
            }
        }

        if (visiblePinCounter > 0) {
            center_map($.smap);
        }
    };

    $.initMap = function initMap() {
        try {
            $(".map").each(function () {
                $.smap = new_map($(this));

                google.maps.event.addListener($.smap, "zoom_changed", function () {
                    if ($.smap.markers.length == 1) {
                        $.smap.setCenter($.smap.markers[0].getPosition());
                        $.smap.panBy(0, -iconHeight / 2);
                    }
                    return;
                });
            });
        } catch (error) {
            //console.error("Error initializing map:", error);
            setTimeout($.initMap, 500);
        }
    };

    $(function () {
        $.initMap();
    });
})(jQuery);
